<template>
  <SelectWithSearch
    label="Exibilidade do ISS"
    placeholder="Selecione a exibilidade"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="issExibilityCollection"
    :filterBy="descriptionFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
    <template slot="no-options"> Selecione uma exigibilidade </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectIssExibility',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    default: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setIssExibilityCollection();

    if (this.default && !this.input) {
      const [defaultOption] = this.issExibilityCollection;
      this.$emit('input', defaultOption);
    }
  },
  computed: {
    ...mapState('fiscalComponents', ['issExibilityCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setIssExibilityCollection']),

    change(value) {
      this.$emit('input', value);
    },
    formatOptions(props) {
      return `${props.data.id} - ${props.data.description}`;
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
